// extracted by mini-css-extract-plugin
module.exports = {"result":"result--g3Pc-","avatar":"avatar--3AI2N","username":"username--2-Ywx"};